/**
 * 报告结果刷新服务
 */
export interface FtoReportResultRefresh {
    /**
     * 刷新报告结果
     */
    refresh(): Promise<void>;
}

export const FtoReportResultRefresh = Symbol.for('FtoReportResultRefresh');
